module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAPlJREFUKBWtkTFqAlEURZ2xFsQd2FgGU6YQZhNBbFMIEVJkA1oILsFGW8G4AMUdpLHXapp0EQLaxch47vDfoPErFj44vDf3vvv/h8nl7lFJklRhAjF8wxzqV89m4RV+QYEPGMIKVCMIzg5A1E0KzaBkC8x56ILqzfSsI+p5uikLZSYDup68PtbSGTGG8ZnhBLwmqMq2E7qhQN+a6OkbpxXNs+ACocaJ9m2+9YhhD0sT0k6goXdQnRODD7QI/mDw37PwGFM1hRd4hj4opGpdCoaY7/CjLVc7+qebdUDDG5aIGUAFniD9PfQeqBR+vBj2GQTa8AUPPv9m7QCRHwBQ6vzLzAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/search.png
// module id = /DBc
// module chunks = 265